import React, { useState } from 'react';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';

export const DayRangePicker = ({
  name,
  setValue,
  defaultValue,
  orientation = 'horizontal',
  filterOnlyDay = false,
}: any) => {
  const [focusedInput, setFocusedInput] = useState(null) as any;
  const [dateRange, setDateRange] = useState({
    startDate: defaultValue.startDate ? moment(defaultValue.startDate) : null,
    endDate: defaultValue.endDate ? moment(defaultValue.endDate) : null,
  }) as any;
  return (
    <DateRangePicker
      orientation={orientation}
      minimumNights={0}
      startDate={dateRange.startDate}
      startDateId={`startDate ${name}`}
      endDate={dateRange.endDate}
      endDateId={`endDate ${name}`}
      onDatesChange={({ startDate, endDate }: any) => {
        const value = {
          startDate: startDate ? moment(startDate).format(filterOnlyDay ?  'YYYY-MM-DD' : 'YYYY-MM-DDT00:00:00') : null,
          endDate: endDate ? moment(endDate).format(filterOnlyDay ?  'YYYY-MM-DD' : 'YYYY-MM-DDT23:59:59'): null,
        };
        setValue(name, value);
        setDateRange({ startDate, endDate });
      }}
      focusedInput={focusedInput}
      onFocusChange={(input: any) => setFocusedInput(input)}
      hideKeyboardShortcutsPanel
      isOutsideRange={() => false}
      minDate={moment('2020-01-01')}
      displayFormat="DD-MM-YYYY"
      small
    />
  );
};
